/**
 * The colours used to accent the UI.
 */
export const ACCENT_COLOR = {
  main: {
    hue: 120,
    saturation: 18,
    lightness: 71,
  },
  darker: {
    hue: 120,
    saturation: 18,
    lightness: 35,
  },
  contrastText: {
    hue: 120,
    saturation: 18,
    lightness: 20,
  },
  background: {
    hue: 120,
    saturation: 18,
    lightness: 86,
  },
  backgroundContrastText: {
    hue: 120,
    saturation: 4,
    lightness: 29,
  },
};
